import { convexQuery } from '@convex-dev/react-query';
import { api } from '@repo/backend/_generated/api';
import { createFileRoute } from '@tanstack/react-router';
import { ExploreCampaigns } from '@/features/explore-campaigns';

export const Route = createFileRoute('/_authenticated/campaigns/')({
    head: () => ({ meta: [{ title: 'Explore Campaigns | promote.fun' }] }),
    loader: async ({ context }) => {
        const firstPage = { paginationOpts: { numItems: 15, cursor: null }, search: undefined, platform: undefined, sort: 'newest' } as const;
        // Block render until the active grid (default sort) is cached; prefetch completed in the background.
        await context.queryClient.ensureQueryData(convexQuery(api.campaigns.listCampaigns, { status: 'active', ...firstPage }));
        void context.queryClient.prefetchQuery(convexQuery(api.campaigns.listCampaigns, { status: 'completed', ...firstPage }));
    },
    component: ExploreCampaigns,
});
